module.exports = __webpack_public_path__ + "static/media/CT_CC (Discovery Trail).521a8c7c.png";